(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('RubroDetailController', RubroDetailController);

    RubroDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Rubro', 'Comercio'];

    function RubroDetailController($scope, $rootScope, $stateParams, previousState, entity, Rubro, Comercio) {
        var vm = this;

        vm.rubro = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mVtasWebApp:rubroUpdate', function(event, result) {
            vm.rubro = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
